import React from "react";
import * as Lucide from "lucide-react";

export default function Icon({ name, className, ...props }) {
  const Cmp = Lucide[name] || Lucide.Sparkles;
  return <Cmp className={className} {...props} />;
}
